<script setup>
  import { format } from "date-fns";
  import { ko } from "date-fns/locale";

  const props = defineProps({
    date: Date,
  });
</script>

<template>
  <n-flex align="center" justify="center" class="chat-date-box">
    <span>
      {{ format(date, "yyyy년 MM월 dd일 EEEE", { locale: ko }) }}
    </span>
  </n-flex>
</template>

<style lang="scss" scoped>
  .chat-date-box {
    margin: 1rem 0;
    span {
      background: rgba(0, 0, 0, 0.3);
      border-radius: 100px;
      color: var(--smoe-white);
      display: inline-flex;
      font-size: 0.875rem;
      padding: 0.25rem 1rem;
    }
  }
</style>
